import React from "react";
import SurveyCondensedTable from "../../../SurveyCondensedTable"
import { NumberFormat, PlaceholderFormat } from "../../../../Enums/constants"
import { handleHOTChangeCustomAsset, CustomGroupingCells, renderCustomGroupingTotalRow } from "./CustomAssetTableHandler";
import { observer } from "mobx-react";

export const CustomAssetTable = observer((props) => {
    let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;

    return (
        <SurveyCondensedTable tableName={"CustomGroupings"}
            handleHOTChange={handleHOTChangeCustomAsset}
            headers={["CustomAssetName", "Constituents", "Nav", "ReturnPct", "ReturnBmPct", "CustomAssetID", "del"]}
            columns={[
                { data: 'CustomAssetName' },
                { data: 'Constituents', type: 'dropdown', placeholder: 'See all constituents', className: 'constituentsField' },
                { data: 'NAV', readOnly: true },
                { data: 'ReturnPct' },
                { data: 'ReturnBmPct' },
                { data: 'CustomAssetID' },
                { data: 'del', className: 'delCol' },
            ]}
            cells={CustomGroupingCells}
            colWidths={['200px', '400px', '105px', '105px', '200px', '105px', '105px']}
            hiddenColumns={[]}
            formatting={['', '', NumberFormat.MONEYMILLION, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, '']}
            nestedHeaders={[
                [`Name of custom group`,
                    'Constituents',
                    `NAV <br/>${currencyPlaceHolderMilsForHeader}<br/>`,
                    'Net return %',
                    'Benchmark %', '']
            ]}
            helpText={["", "", "", "If net return is not provided, CEM will estimate it as the asset-weighted return of the underlying holdings.", "If benchmark return is not provided, CEM will estimate it as the asset-weighted return of the underlying holdings."]}
            addRowBtnName={"Add Custom Asset"}
            includeTotalRow
            renderTotalRow={renderCustomGroupingTotalRow}

        />
    );

});
export default CustomAssetTable;